import { render } from "./processOnBoard.vue?vue&type=template&id=388d5c80&scoped=true&ts=true"
import script from "./processOnBoard.vue?vue&type=script&lang=ts"
export * from "./processOnBoard.vue?vue&type=script&lang=ts"

import "./processOnBoard.vue?vue&type=style&index=0&id=388d5c80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388d5c80"]])

export default __exports__